import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  IconButton,
  CircularProgress,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import { useDispatch } from 'react-redux';
import { downloadCustomUploadedFile } from '../../../../containers/actions/common/fileActions';
import { useStyles } from './CommonModalStyles';

const CommonModal = ({ 
  open, 
  onClose, 
  title, 
  tableData, 
  columns, 
  showUploadButton, 
  uploadButtonText, 
  showOkButton = true, 
  modalType = 'documents', 
  renderCell,
  loading = false,
  onDownloadSuccess,
  onDownloadError,
}) => {
  const classes = useStyles({ modalType });
  const dispatch = useDispatch();

  const handleDocumentClick = (document) => {
    // Use the same pattern as digitized information section
    // The Redux action downloadCustomUploadedFile expects { schrockenCustomFileID }
    // We'll use documentId as schrockenCustomFileID (backend should handle it)
    // Or if document has schrockenCustomFileID, use that
    const fileId = document.schrockenCustomFileID || document.documentId;
    
    if (fileId) {
      const data = {
        schrockenCustomFileID: fileId
      };
      // Redux action handles backdrop, API call, and download automatically
      dispatch(downloadCustomUploadedFile(data));
      
      // Show success notification after a delay (Redux action handles backdrop and download)
      // Note: The Redux action doesn't provide success callback, so we use setTimeout
      setTimeout(() => {
        if (onDownloadSuccess) {
          onDownloadSuccess(`Document "${document.documentName}" downloaded successfully`);
        }
      }, 1500);
    } else {
      // Fallback: show error if no file ID available
      if (onDownloadError) {
        onDownloadError(`Download not available - missing file ID for: ${document.documentName}`);
      }
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" className={classes.dialog}>
      <DialogTitle className={classes.dialogTitle}>
        <Typography className={classes.title}>{title}</Typography>
        <div className={classes.closeButton} onClick={onClose}>
          <Typography className={classes.closeText}>Close</Typography>
          <CloseIcon className={classes.closeIcon} />
        </div>
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <TableContainer component={Paper} className={classes.tableContainer} elevation={0}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                {columns.map((column, index) => (
                  <TableCell key={index} align="left" className={classes.headerCell}>
                    {column}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={columns.length} align="center" className={classes.tableCell}>
                    <CircularProgress size={24} />
                    <Typography variant="body2" style={{ marginTop: '8px' }}>
                      Loading documents...
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : tableData && tableData.length > 0 ? (
                tableData.map((row, index) => (
                  <TableRow key={index}>
                    {columns.map((column, colIndex) => {
                      if (renderCell) {
                        return renderCell(row, colIndex, column, classes);
                      }
                      
                      // Map column names to row property names
                      const columnToKeyMap = {
                        'Document Name': 'documentName',
                        'Document Type': 'documentType',
                        'Version': 'version',
                        'Upload Date': 'uploadDate',
                      };
                      
                      const rowKey = columnToKeyMap[column] || column.toLowerCase().replace(/\s+/g, '');
                      const cellValue = row[rowKey] || '';
                      
                      return (
                        <TableCell key={colIndex} align="left" className={classes.tableCell}>
                          {colIndex === 0 && modalType === 'documents' && row.s3Url ? (
                            <span 
                              className={classes.documentName}
                              onClick={() => handleDocumentClick(row)}
                              style={{ cursor: 'pointer' }}
                            >
                              {cellValue}
                            </span>
                          ) : (
                            cellValue
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={columns.length} align="center" className={classes.tableCell}>
                    <Typography variant="body2">No documents found</Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        {showUploadButton && (
          <Box style={{ width: '100%', maxWidth: modalType === 'activeBatches' ? '100%' : '700px', display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
            <Button
              startIcon={<AddIcon />}
              className={classes.uploadButton}
              onClick={() => console.log(uploadButtonText)}
            >
              {uploadButtonText}
            </Button>
            <Button
              className={classes.digitalizedMbrButton}
              onClick={() => console.log('Digitalized MBR')}
            >
              Digitalized MBR
            </Button>
          </Box>
        )}
      </DialogContent>
      {showOkButton && (
        <DialogActions style={{ padding: '20px 24px', justifyContent: 'center' }}>
          <Button onClick={onClose} className={classes.okButton}>
            Ok
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default CommonModal;

